import React from 'react';
import { useTranslation } from 'react-i18next';
import CallControlIcon from 'components/atoms/icons/callControlIcon';
import FalseMonthlyInteractionIcon from 'components/atoms/icons/falseMontlyInteractionIcon';
import { useUpdateInteractionStatus } from 'infrastructure/hooks/control-panel';
import PatientControlButton from 'components/atoms/patentControlButton';
import { useAccess } from 'infrastructure/hooks/access/useAccess';
import useMonthlyInteractionAlert from 'infrastructure/hooks/utils/use-monthly-interaction-alert';
import useUser from 'utils/useUser';

import type { ModuleType } from 'infrastructure/enums';

interface IProps {
  module: ModuleType;
  patientGuid: string;
}

const MonthlyInteractionControl: React.FC<IProps> = (props) => {
  const { module, patientGuid } = props;
  const { t } = useTranslation();

  const { isPractice } = useUser();
  const { MonthlyInteractionAlert, showMonthlyInteractionAlert } =
    useMonthlyInteractionAlert({
      patientGuid,
    });

  const { patientInfo, isCombinedModule, isReadOnlyRole, isBlockRpmModule } =
    useAccess({
      module,
      patientGuid,
    });

  const { updateInteractionStatus, updateInteractionStatusLoading } =
    useUpdateInteractionStatus();

  const interactionStatus = patientInfo?.interactionStatus;

  const icon = interactionStatus
    ? CallControlIcon
    : FalseMonthlyInteractionIcon;
  const status = interactionStatus ? t('controls.yes') : t('controls.no');

  const disabled =
    (isCombinedModule && (isReadOnlyRole || isBlockRpmModule)) ||
    interactionStatus;

  const handleClick = async () => {
    const res = await showMonthlyInteractionAlert({
      ignoreIsShowed: true,
      showSecondAlert: isPractice,
    });
    if (res) {
      updateInteractionStatus({
        patientGuid,
        isInteracted: !interactionStatus,
      });
    }
  };

  return (
    <>
      <PatientControlButton
        label={t('labels.monthlyInteractionRpm')}
        Icon={icon}
        status={status}
        loading={updateInteractionStatusLoading}
        disabled={disabled}
        handleClick={handleClick}
        extraAccent={!interactionStatus}
      />
      {MonthlyInteractionAlert}
    </>
  );
};

export default MonthlyInteractionControl;
